import { Stack } from '@mui/material';
import React from 'react';

export const SignalOnCallScheduleResponsiveLayout = ({
  isMobile,
  sidebar,
  calendar,
}: {
  isMobile: boolean;
  sidebar: React.ReactNode;
  calendar: React.ReactNode;
}) => {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      sx={{ flex: 1, width: '100%', minHeight: 0 }}
      data-testid="signal-schedule-layout"
    >
      {!isMobile ? <Stack data-testid="signal-schedule-sidebar">{sidebar}</Stack> : null}
      <Stack
        flexGrow={1}
        sx={{ width: '100%', minWidth: 0, minHeight: 0, overflow: 'hidden' }}
        data-testid="signal-schedule-calendar-column"
      >
        {calendar}
      </Stack>
    </Stack>
  );
};
